import { inject, injectable } from "inversify";
import { HTTP_SERVICE_NAME, HttpService } from "../../http/HttpService";
import { formatDate } from "../../../ui/util/date";

export interface CaribbeanPokerHandHistoryService {
    listHandHistory(req: CaribbeanPokerHandHistoryListRequest): Promise<CaribbeanPokerHandHistoryListResponse>;

    getHand(id: String): Promise<Game>;
}

export interface CaribbeanPokerHandHistoryListRequest {
    userId: string;
    startTime: number;
    endTime: number;
    currency: string;
    offset?: number;
}

export interface CaribbeanPokerHandHistoryListResponse {
    totalResults: number;
    limit: number;
    hands: Game[];
}

export interface Game {
    gameId: string;
    userId: number;
    playerHand: Hand;
    dealerHand: Hand;
    gameResult: string;
    ante: number;
    raise: number;
    winnings: number;
    currency: 'GC' | 'SC';
    startTime: string;
    endTime: string;
}

export interface Hand {
    cards: string[];
    handRank:
      | 'HighCard'
      | 'OnePair'
      | 'TwoPair'
      | 'ThreeOfAKind'
      | 'Straight'
      | 'Flush'
      | 'FullHouse'
      | 'FourOfAKind'
      | 'StraightFlush'
      | 'RoyalFlush'
      | 'NotQualified';
    handState: 'PLAY' | 'WIN' | 'LOST' | 'PUSH' | 'NONE' | 'RAISE' | 'FOLD';
}

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

@injectable()
export class CaribbeanPokerHandHistoryServiceImpl implements CaribbeanPokerHandHistoryService {

    http: HttpService;

    getHand(id: string): Promise<Game> {
        return this.http.doGet("/caribbean-poker/hand-history/hand/" + id);
    }

    constructor(@inject(HTTP_SERVICE_NAME) http: HttpService) {
        this.http = http;
    }

    listHandHistory(req: CaribbeanPokerHandHistoryListRequest): Promise<CaribbeanPokerHandHistoryListResponse> {
        const path = `/caribbean-poker/hand-history/hands?` +
        `start_time=${encodeURI(formatDate(req.startTime, DATE_FORMAT))}&`+
        `end_time=${encodeURI(formatDate(req.endTime, DATE_FORMAT))}&` +
        `user_id=${encodeURI(req.userId)}&` +
        `currency=${encodeURI(req.currency)}&` +
        `offset=${encodeURI((req.offset || 0).toString())}`;
        return this.http.doGet(path);
    }
}


// WEBPACK FOOTER //
// ./src/app/service/caribbean-poker/history/CaribbeanPokerHandHistoryService.tsx